var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HasSubscriptions } from '../has-subscriptions';
import { DirectoryTypes } from '../../classes/enums';
import { DIRECTORY_STRUCTURE_CONFIG } from '../../app-config.constants';
import { InternalLinksService } from '../../services/internalLinks.service';
import { CommunicationService } from '../../services/communication.service';
import { MetaTagService } from '../../services/meta-tag.service';
import { map } from 'rxjs/operators';
var DirectoryPageComponent = /** @class */ (function (_super) {
    __extends(DirectoryPageComponent, _super);
    function DirectoryPageComponent(activatedRoute, internalLinksService, metaTagService, communicationService) {
        var _this = _super.call(this) || this;
        _this.activatedRoute = activatedRoute;
        _this.internalLinksService = internalLinksService;
        _this.metaTagService = metaTagService;
        _this.communicationService = communicationService;
        return _this;
    }
    DirectoryPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.activatedRoute.data.subscribe(function (_a) {
            var directoryType = _a.directoryType;
            _this.setPageConfiguration(directoryType);
            _this.setDirectories(directoryType);
            _this.setSEOItems();
        }));
        this.addSub(this.communicationService.listings.currentShownListingType.subscribe(function (listingCategory) {
            _this.listingCategory = listingCategory;
        }));
        this.communicationService.footerLinksChange.next({ city: null, province: null });
    };
    DirectoryPageComponent.prototype.setDirectories = function (directoryType) {
        var _this = this;
        var linksCall;
        if (directoryType === DirectoryTypes.NEIGHBOURHOOD) {
            linksCall = this.internalLinksService.getNeighborhoodLinksForProvinces(100).pipe(map(function (result) { return _this.generateNeighbourhoodLinks(result); }));
        }
        else {
            linksCall = this.internalLinksService.getDirectoryForProvinces(this.listingCategory, directoryType).pipe(map(function (result) { return _this.generateDirectoryCityLinks(result); }));
        }
        this.addSub(linksCall.subscribe(function (data) {
            _this.directoryLinks = data;
        }));
    };
    DirectoryPageComponent.prototype.generateDirectoryCityLinks = function (result) {
        var _this = this;
        return result.provinceLinks.map(function (provinceLink) {
            var stateShortLowerCase = provinceLink.stateShort.toLowerCase();
            return {
                province: "provinces." + stateShortLowerCase,
                visible: false,
                showMore: false,
                cityCardLinks: _this.pageConfig.cardStructure ? _this.generateCityCardLinks(provinceLink.cities, stateShortLowerCase) : null
            };
        });
    };
    DirectoryPageComponent.prototype.generateNeighbourhoodLinks = function (result) {
        return result.neighbourhoodLinks.map(function (neighbourhoodLink) {
            var stateShortLowerCase = neighbourhoodLink.stateShort.toLowerCase();
            var steps = ((neighbourhoodLink.neighbourhoods.length - 50) / 25);
            return {
                province: "provinces." + stateShortLowerCase,
                visible: false,
                showMore: 0,
                listLinks: neighbourhoodLink.neighbourhoods
            };
        });
    };
    DirectoryPageComponent.prototype.generateCityCardLinks = function (cities, stateShortLowerCase) {
        var _this = this;
        return cities.map(function (city) {
            var cityNoSpace = city.replace(/[^A-Z0-9]+/ig, '-').toLowerCase();
            return {
                title: city,
                main: {
                    url: "/" + stateShortLowerCase + "/" + cityNoSpace + _this.pageConfig.cardStructure.main.urlSuffix,
                    title: _this.pageConfig.cardStructure.main.title,
                    icon: ''
                },
                subLink1: {
                    url: "/" + stateShortLowerCase + "/" + cityNoSpace + _this.pageConfig.cardStructure.sub1.urlSuffix,
                    title: _this.pageConfig.cardStructure.sub1.title,
                    icon: _this.pageConfig.cardStructure.sub1.icon
                },
                subLink2: {
                    url: "/" + stateShortLowerCase + "/" + cityNoSpace + _this.pageConfig.cardStructure.sub2.urlSuffix,
                    title: _this.pageConfig.cardStructure.sub2.title,
                    icon: _this.pageConfig.cardStructure.sub2.icon
                }
            };
        });
    };
    DirectoryPageComponent.prototype.setSEOItems = function () {
        var title = "directory-page.meta-tags." + this.metaPrefix + ".title";
        var description = "directory-page.meta-tags." + this.metaPrefix + ".description";
        this.createMetaDataTags(title, description, {}, {});
    };
    DirectoryPageComponent.prototype.setPageConfiguration = function (directoryType) {
        switch (directoryType) {
            case DirectoryTypes.OPEN_HOUSE:
                this.metaPrefix = 'open-houses';
                this.pageConfig = DIRECTORY_STRUCTURE_CONFIG.openHouse;
                break;
            case DirectoryTypes.LISTING:
                this.metaPrefix = 'real-estate';
                this.pageConfig = DIRECTORY_STRUCTURE_CONFIG.listing;
                break;
            case DirectoryTypes.AGENT:
                this.metaPrefix = 'real-estate-agents';
                this.pageConfig = DIRECTORY_STRUCTURE_CONFIG.agent;
                break;
            default:
                this.metaPrefix = 'neighbourhood';
                this.pageConfig = DIRECTORY_STRUCTURE_CONFIG.neighborhood;
                break;
        }
    };
    DirectoryPageComponent.prototype.createMetaDataTags = function (titleString, descriptionString, titleVariables, descriptionVariables) {
        this.metaTagService.setPageTitle(titleString, titleVariables);
        this.metaTagService.setPageDescription(descriptionString, descriptionVariables);
        var openGraphTags = [
            {
                name: 'title',
                content: titleString,
                variables: titleVariables,
                isTranslateKey: true
            },
            {
                name: 'description',
                content: descriptionString,
                variables: descriptionVariables,
                isTranslateKey: true
            }
        ];
        this.metaTagService.setOpenGraphTags(openGraphTags);
    };
    DirectoryPageComponent.prototype.updateShownValue = function (showMore) {
        return ((showMore + 1) % 3);
    };
    return DirectoryPageComponent;
}(HasSubscriptions));
export { DirectoryPageComponent };
